import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_92q2hhsl: FaireBrandEntity = {
  token: "b_92q2hhsl",
  type: "brand",
  name: "Tiny Rituals",
  avatarUrl:
    "https://cdn.faire.com/fastly/ee01f682ee1059022130cd497478adaf2538fe1aba555b07668c4d4f49dc34ae.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d0aaf48bc5f0b6376bc2135f55f1fd8d379a81150fa0f584ba8c952e7800749e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ee01f682ee1059022130cd497478adaf2538fe1aba555b07668c4d4f49dc34ae.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d0aaf48bc5f0b6376bc2135f55f1fd8d379a81150fa0f584ba8c952e7800749e.png",
  location: "Encinitas, CA, USA",
  minimumOrderDollars: 277,
  rating: 4.8,
  reviewCount: 30,
  isInsider: true,
  description:
    "For those seeking meaning, inspired by intention, & connected by ritual. 10% of profits protect children in need. \n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:09.577Z",
    importedBy: "entity-db-cli",
  },
};
